import { IRequestTokenDetails } from './IRequestTokenDetails';
import { GlobalAppLoaderName, TokenAttributeOnMiniApp } from '../AppLoader/constants';
import { TokenExchanger } from './TokenExchanger';
import { IAppLoader } from '../AppLoader/IAppLoader';
import { ITokenConfig } from './index';
import { sdkLoggerInterface as log } from '../Logger/Logger';

/**
 * Will help in generating the Mini-app token using the Token exchange call
 * based on the Shell/container details passed in.
 * @param tagName Name of tag identifier for the mini-app
 * @param tokenConfig Seeds Token configuration that will be used for token exchange.
 * @param seedTokenProvider This is a function passed into the token exchange to get a new seed/actor token, Must return a promise with a string.
 * Details like seed Client ID, seed token and DAF URL used by the shell(Parent container), will drive the token exchange
 */
async function generateToken(tagName: string, tokenConfig: ITokenConfig, seedTokenProvider: () => Promise<string>): Promise<string> {
    try {
        /**
         * Accessing the window object for App Loader instance to get the cached data.
         */
        return await TokenExchanger.generateMiniAppToken(tagName, tokenConfig, seedTokenProvider);
    } catch (error) {
        log.error('Error getting token', error);
        return Promise.reject(error);
    }
}
/**
 * tokenRequestSubscribe - Subscribe to the renew token exchange and setting the attribute to the new token.
 * @param {CustomEventInit<IRequestTokenDetails>} event - EventMgr event published to request a Token exchange.
 * This event will have details like the Element that will be used to update the Auth attribute on.
 * tagName of the mini-app that will be used to get the cached information.
 */
export async function tokenRequestSubscribe(event: CustomEventInit<IRequestTokenDetails>) {
    const appLoader = window[GlobalAppLoaderName] as IAppLoader;
    const { detail = {} } = event || {};
    const { renderRoot = null, tagName = '', tokenConfig = null, seedTokenProvider = null } = detail as IRequestTokenDetails;
    let token = '';
    if (renderRoot && tagName) {
        try {
            token = await generateToken(tagName, tokenConfig, seedTokenProvider);
            renderRoot.setAttribute(TokenAttributeOnMiniApp, token);

            // this line is introduced for backward compatibility of an issue in @nab/nab-x-react v3.0.0
            // we require this to be in until we have an confirmation that all the mini-app have upgraded to @nab/nab-x-react v3.0.0
            renderRoot[TokenAttributeOnMiniApp] = token;
        } catch (e) {
            log.error(`Error calling and setting token for ${tagName}`, e);
        }
    }
    /**
     * once the token is generated we cache the token on the AppLoader cache
     */
    if (appLoader && token) {
        const cachedConfig = appLoader.getConfig(tagName);
        /* istanbul ignore next */
        if (cachedConfig) {
            cachedConfig.token = token;
        }
    }
}
